import { numberSeparatorMap } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setFieldSettingsThousandsAndDecimalField: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_THOUSANDS_AND_DECIMAL_FIELD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.fieldsById[change.fieldId].customNumberFormat.thousandsSeparator =
      change.newValue.thousandsSeparator &&
      numberSeparatorMap[change.newValue.thousandsSeparator];
    db.fieldsById[change.fieldId].customNumberFormat.decimalSeparator =
      numberSeparatorMap[change.newValue.decimalSeparator];
  });
};
